import { SxProps } from '@mui/material';

export const AIMessageSx: SxProps = {
  backgroundColor: 'bgSwitch',
};

export const userMessageSx: SxProps = {
  backgroundColor: 'base.50',
  marginLeft: 'auto !important',
  maxWidth: '90%',
};
